export default {
  title: {
    messages: "الرسائل",
    messagesManagement: "إدارة الرسائل"
  },
  showMoreButton: "عرض المزيد من الرسائل",
  noMassages: "ليس لديك رسائل",
  readAllButton: "وضع علامة كـ مقروء"
};
